/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'macmini_dark_large': {
    width: 28,
    height: 54,
    viewBox: '0 0 28 54',
    data: '<path pid="0" _fill="#EFEFEF" d="M0 44v6c0 .611.391 1 1 1h26c.609 0 1-.389 1-1v-6H0zm24.499 2.5a1 1 0 1 1 1.001-.999.998.998 0 0 1-1.001.999z"/>'
  }
})
